import React from 'react'
import "./HomeAdmin.scss"
import { jwtDecode } from "jwt-decode"
import VistaConsultorasAdmin from '../../components/Admin/superAdmin/VistaConsultorasAdmin'
import VistaEmpresasAdmin from "../../components/Admin/consultora/VistaEmpresasAdmin"
import VistaGerenteAdmin from '../../components/Admin/empresa/VistaGerenteAdmin'

function HomeAdmin() {
  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  const title = (
    <>
      <div className='section__header d-flex flex-row align-items-end mb-4'>
        <i className='bi bi-people-fill me-2'></i>
        <h4 className='m-0'>Admin</h4>
      </div>
    </>
  )

  if(USER.puesto === 1) {
    return (
      <div className='home__admin section'>
        {title}
        <VistaConsultorasAdmin user={USER}/>
      </div>
    )
  }

  if(USER.puesto === 2) {
    return (
      <div className='home__admin section'>
        {title}
        <VistaEmpresasAdmin user={USER}/>
      </div>
    )
  }

  if(USER.puesto === 3) {
    return (
      <div className='home__admin section'>
        {title}
        <VistaGerenteAdmin user={USER}/>
      </div>
    )
  }
}

export default HomeAdmin